<template>
    <div class="scene-list-box">
        <SceneItem :data="item" @sceneClick="sceneClick" v-for="(item, index) in sceneData" :key="index" :level="index" />
    </div>
</template>

<script>
import SceneItem from "@/views/zhiji/components/pagesPanel/SceneItem";

export default {
    name: "SatisfSceneList",
    props: ["startDate", "endDate", "quesType", "channelType", "langType", "order"],
    components: {
        SceneItem
    },
    data() {
        return {
            activeSceneData: [],
            sceneData: {
                "1": [],
                "2": [],
                "3": []
            },
            startTimeChange: this.startDate || "",
            endTimeChange: this.endDate || "",
            langTypeChange: this.langType || "all",
            quesTypeChange: this.quesType || "all",
            channelTypeChange: this.channelType || "all",
            treeData: [],
            orderChange: "1"
        };
    },
    watch: {
        treeData: {
            handler(data) {
                if (data && data.length > 0) {
                    this.sceneData["1"] = data;
                }
            },
            immediate: true,
            deep: true
        },
        order(newVal) {
            this.orderChange = newVal;
            this.querySortSetInfo();
        },
        startDate(newVal) {
            this.startTimeChange = newVal;
            this.querySortSetInfo();
        },
        endDate(newVal) {
            this.endTimeChange = newVal;
            this.querySortSetInfo();
        },
        quesType(newVal) {
            this.quesTypeChange = newVal;
            this.querySortSetInfo();
        },
        channelType(newVal) {
            this.channelTypeChange = newVal;
            this.querySortSetInfo();
        },
        langType(newVal) {
            this.langTypeChange = newVal;
            this.querySortSetInfo();
        }
    },
    mounted() {
        this.querySortSetInfo();
    },
    methods: {
        querySortSetInfo() {
            let request = {
                order: this.orderChange,
                startTime: this.startTimeChange,
                endTime: this.endTimeChange,
                channelType: this.channelTypeChange,
                quesType: this.quesTypeChange,
                langType: this.langTypeChange
            };
            this.zhiji.requestByServiceName("getSatisfySetInfo", request).then(resp => {
                this.treeData = resp;
            });
        },
        sceneClick(data) {
            let level = parseInt(data.level);
            let item = data.item;
            let nextLevel = String(level + 1);

            if (item.id === "all") {
                if (nextLevel === "2") {
                    this.sceneData["3"] = [];
                    this.$emit("sceneItemClick", "");
                } else {
                    let lastSenceId = this.activeSceneData[level - 2].id;
                    this.$emit("sceneItemClick", lastSenceId);
                }
            } else {
                this.activeSceneData[level - 1] = item;
                this.$emit("sceneItemClick", item.id);
            }

            this.sceneData[nextLevel] = [];
            if (item.children && item.children.length > 0) {
                this.sceneData[nextLevel] = item.children;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.scene-list-box {
    margin-top: 8px;
}
</style>
